import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import Layout from '../../layout/Layout';
import Fancybox from '../../Component/FancyBox';
import { API } from '../../App';
import Cookies from 'js-cookie'

const DefultThemeView = () => {
    const { id } = useParams()
    const [loading, Setloading] = useState(false)
    const [category, setCategory] = useState([])
    const [user, setuser] = useState({
        rank: "",
        normal_image: "",
        name: "",
        key_bord_Back_Color: "",
        key_Back_Color: "",
        btn_Back_Color: "",
        btn_Key_Color: "",
        is_Border: "",
        popup_Back_Color: "",
        popup_Text_Color: "",
        status: "",
        border_Color: "",
        text_Color_For_Show_Key_Off: "",
        is_premium: "",
        is_Watch_Video: "",
        created_at: "",
        isImg: "",
        keyboardCategory: "",
        updated_at: ""
    })

    const [LoadData, setLoadData] = useState([])
    const [keyboardCategories, setKeyboardCategories] = useState([])
    let navigate = useNavigate();

    const loadData = async (_id) => {
        Setloading(true)
        const token = Cookies.get('jwt')
        const res = await API.post(`/normalImagesData/`, {}, { headers: { "authorization": `Bearer ${token}` } })
        setLoadData(res.data.data)
        const viewData = await API.post(`/normalImages/${_id}`, {}, { headers: { "authorization": `Bearer ${token}` } })
        setCategory(viewData.data.data._id)
        setuser({
            rank: viewData.data.data.rank,
            normal_image: viewData.data.data.normal_image,
            name: viewData.data.data.name,
            key_bord_Back_Color: viewData.data.data.key_bord_Back_Color,
            key_Back_Color: viewData.data.data.key_Back_Color,
            btn_Back_Color: viewData.data.data.btn_Back_Color,
            btn_Key_Color: viewData.data.data.btn_Key_Color,
            is_Border: viewData.data.data.is_Border,
            popup_Back_Color: viewData.data.data.popup_Back_Color,
            popup_Text_Color: viewData.data.data.popup_Text_Color,
            status: viewData.data.data.status,
            border_Color: viewData.data.data.border_Color,
            text_Color_For_Show_Key_Off: viewData.data.data.text_Color_For_Show_Key_Off,
            is_premium: viewData.data.data.is_premium,
            is_Watch_Video: viewData.data.data.is_Watch_Video,
            created_at: viewData.data.data.created_at,
            isImg: viewData.data.data.isImg,
            updated_at: viewData.data.data.updated_at,
            keyboardCategory: viewData.data.data.keyboardCategory

        })
        Setloading(false)
    }

     const fetchKeyboardCategories = async () => {
            try {
                const token = Cookies.get('jwt')
                const res = await API.post('/keyboardCategories', {}, { 
                    headers: { "authorization": `Bearer ${token}` } 
                })
                setKeyboardCategories(res.data.data || [])
            } catch (error) {
                console.error('Error fetching keyboard categories:', error)
            }
        }

    const getCategory = (e) => {
        setCategory(e.target.value)
        loadData(e.target.value)
        
    }

    useEffect(() => {
        loadData(id)
        fetchKeyboardCategories()

    }, [])
    return (
        <Layout sidebar={true}>
            <div div className="page-heading">
                <h3><Link to="/defaulttheme" className='btn btn-primary btn-icon me-3'><i className='bx bxs-left-arrow-alt'></i></Link>View DefultTheme - <span>{user.name}</span></h3>
                <Row className="align-items-center">
                    <Col md="auto" xs={6}>
                        <Form.Select className="my-1" onChange={(e) => { getCategory(e) }}>
                            {
                                LoadData.map((dataVal, ind) => {
                                    return (
                                        <option key={ind} value={dataVal._id} selected={user.name === dataVal.name ? true : false}>{dataVal.name}</option>
                                    )
                                })
                            }
                        </Form.Select>
                    </Col>
                    <Col md="auto" xs={6}>
                        <Link to={`/defaulttheme/edit/${category} `}>
                            <Button variant="primary" value="edit">Edit</Button>
                        </Link>
                    </Col>
                </Row>
            </div>

            <div className='page-content'>
                <Card>
                    <Card.Body>
                        {
                            loading ? <div className='loader table-loader' ></div> : <></>
                        }
                        <Fancybox>
                            <Row>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>New Index</p> <span>{user.rank}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Name</p> <span>{user.name}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Normal Images</p>
                                        <span>
                                            <Fancybox>
                                            <a data-fancybox="gallery" href={user.normal_image}>
                                                <img src={user.normal_image} className='hv-30 rounded-3' alt="Category" />
                                            </a>
                                            </Fancybox>
                                        </span>
                                    </div>
                                </Col>
                                 <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Keyboard Category</p>
                                        <span>
                                            {keyboardCategories.find(cat => cat._id === user.keyboardCategory)?.name || "Not assigned"}
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Status</p> <span>{user.status === true ? "true" : "false"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Is Premium</p> <span>{user.is_premium === true ? "true" : "false"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Is WatchVideo</p> <span>{user.is_Watch_Video === true ? "true" : "false"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Is Image</p> <span>{user.isImg === true ? "true" : "false"}</span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>BTN BackColor</p> 
                                        <span>
                                            <div className='color-box-group'>
                                                <Form.Control type="color" value={user.btn_Back_Color} className="my-2" disabled />
                                                <div className='color-box' style={{ backgroundColor:user.btn_Back_Color }}></div>
                                            </div>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Button KeyColor</p> 
                                        <span>
                                            <div className='color-box-group'>
                                                <Form.Control type="color" value={user.btn_Key_Color} className="my-2" disabled />
                                                <div className='color-box' style={{ backgroundColor:user.btn_Key_Color }}></div>
                                            </div>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Popup BackColor</p> 
                                        <span>
                                            <div className='color-box-group'>
                                                <Form.Control type="color" value={user.popup_Back_Color} className="my-2" disabled />
                                                <div className='color-box' style={{ backgroundColor:user.popup_Back_Color }}></div>
                                            </div>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Popup TextColor</p> 
                                        <span>
                                            <div className='color-box-group'>
                                                <Form.Control type="color" value={user.popup_Text_Color} className="my-2" disabled />
                                                <div className='color-box' style={{ backgroundColor:user.popup_Text_Color }}></div>
                                            </div>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>Border Color</p> 
                                        <span>
                                            <div className='color-box-group'>
                                                <Form.Control type="color" value={user.border_Color} className="my-2" disabled />
                                                <div className='color-box' style={{ backgroundColor:user.border_Color }}></div>
                                            </div>
                                        </span>
                                    </div>
                                </Col>
                                <Col md={3}>
                                    <div className='mb-4'>
                                        <p className='mb-0 fw-bold'>TextColor For ShowKeyOff</p>
                                        <span>
                                            <div className='color-box-group'>
                                                <Form.Control type="color" value={user.text_Color_For_Show_Key_Off} className="my-2" disabled />
                                                <div className='color-box' style={{ backgroundColor:user.text_Color_For_Show_Key_Off }}></div>
                                            </div>
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        </Fancybox>
                    </Card.Body>
                </Card>
            </div>
        </Layout>
    )
}

export default DefultThemeView